import { getRangeMinMax } from '../reducers/utils/range/get-range-min-max.ts';
import { type SelectionState } from '../state/types.ts';

export function isRowIndexSelectedInRowMode(
  state: SelectionState,
  rowIndex: number
): boolean {
  if (state.mode !== 'row') {
    return false;
  }

  for (const range of state.selections) {
    const { min, max } = getRangeMinMax(range, 'row');

    if (rowIndex >= min && rowIndex <= max) {
      return true;
    }
  }

  return false;
}
